import { useState } from 'react'
import { useGetCoupons, useGetImageTypeBanners } from '@/apis/rest/generated/hooks'
import { CouponUsedStatusEnum } from '@/apis/rest/generated/types/couponUsedStatusEnum'
import { ImageTypeBannerAreaEnum } from '@/apis/rest/generated/types/imageTypeBannerAreaEnum'
import { UserCouponListStatusEnum } from '@/constants/user-coupon-list-status.enum'
import { usePetType } from '@/containers/hooks'
import { UserContainer } from '@/containers/users/UserContainer'
import { createCouponList } from '@/utils/coupon.util'

const couponItems = [
  { id: 'available', title: '사용 가능', status: UserCouponListStatusEnum.Available },
  { id: 'usedExpired', title: '사용 완료/불가', status: UserCouponListStatusEnum.UsedExpired },
]

const useCouponList = (initCouponStatus?: UserCouponListStatusEnum) => {
  const { getPetType } = usePetType()
  const { me } = UserContainer.useContainer()
  const [couponStatus, setCouponStatus] = useState<UserCouponListStatusEnum>(
    initCouponStatus || UserCouponListStatusEnum.Available
  )
  const isAvailableCouponStatus = UserCouponListStatusEnum.Available === couponStatus
  const { data: bannerImageData, isError: isBannerError } = useGetImageTypeBanners(
    {
      area: [ImageTypeBannerAreaEnum.COUPON],
      petType: getPetType(),
    },
    {
      query: {
        enabled: !!me,
        select: (data) => data[0],
      },
    }
  )

  const {
    data: couponListData,
    isLoading: isLoadingCouponList,
    isError: isErrorCouponList,
  } = useGetCoupons(
    {
      usedStatuses: isAvailableCouponStatus
        ? [CouponUsedStatusEnum.UNUSED]
        : [CouponUsedStatusEnum.USED, CouponUsedStatusEnum.EXPIRED],
    },
    {
      query: {
        enabled: !!me,
      },
    }
  )

  const getCouponStatusById = (id: string): UserCouponListStatusEnum => {
    return couponItems.find((item) => item.id === id)?.status || UserCouponListStatusEnum.Available
  }

  return {
    couponListData,
    couponStatus,
    isLoadingCouponList,
    isErrorCouponList,
    totalCount: couponListData?.count ?? 0,
    couponList: createCouponList(couponListData),
    isBannerError,
    bannerImageData,
    getCouponStatusById,
    setCouponStatus,
    isAvailableCouponStatus,
  }
}

export { couponItems, useCouponList }
